import NotificationBell from '../../assets/img/icons/notification-bell.svg?react';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';
import useNotifications from './hooks/useNotifications';

const Button = styled.button`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 42px;
  width: 40px;
  position: relative;
  border: none;
  background-color: transparent;

  svg {
    fill: ${({ theme }) => theme.colors.white};
  }

  &:hover {
    svg {
      opacity: 0.9;
    }
  }

  &:focus {
    outline: solid 3px ${({ theme }) => theme.palette.gold};
  }

  &:hover,
  &:active,
  &:focus,
  &.active {
    background-color: ${({ theme }) => theme.palette.blackTint(37)};
  }
`;

interface Props extends HTMLAttributes<HTMLButtonElement> {
  isOpen?: boolean;
}
const NotificationButton = ({ isOpen, ...props }: Props): JSX.Element => {
  const notifications = useNotifications();

  const hasUnreadNotifications = notifications.some((notification) => !notification.pushIsRead);

  return (
    <Button {...props} data-pendo-id="notifications">
      <NotificationBell />
      {hasUnreadNotifications && <span className="notifications-unread-indicator" />}
    </Button>
  );
};

export default NotificationButton;
